module.exports = __webpack_public_path__ + "static/media/Niger.968c8f10.png";